import React, { useState } from 'react';
import { useOnboarding } from '../OnboardingContext';

export default function StepCompany({ onNext }) {
  const { state, merge } = useOnboarding();
  const [company, setCompany] = useState(state.company?.name || '');
  const [location, setLocation] = useState(state.locations && state.locations[0]?.name ? state.locations[0].name : '');

  const handleNext = () => {
    // merge company and first location into onboarding state
    const locs = state.locations && state.locations.length ? state.locations.slice() : [];
    if (locs.length === 0) locs.push({ name: location }); else locs[0] = { ...locs[0], name: location };
    merge({ company: { name: company }, locations: locs });
    onNext?.();
  };

  return (
    <div style={{padding:24}}>
      <h3>Company Setup</h3>
      <div style={{ marginTop: 8 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>
          Company name
          <input value={company} onChange={(e) => setCompany(e.target.value)} style={{ marginLeft: 8, padding: '8px 10px', borderRadius: 6, border: '1px solid #d6dbe5' }} />
        </label>

        <label style={{ display: 'block', marginTop: 12 }}>
          Location name
          <input value={location} onChange={(e) => setLocation(e.target.value)} style={{ marginLeft: 8, padding: '8px 10px', borderRadius: 6, border: '1px solid #d6dbe5' }} />
        </label>
      </div>

      <div style={{marginTop:12}}>
        <button onClick={handleNext}>Next</button>
      </div>
    </div>
  );
}
